import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Context } from "../../context/Context";
import { FaUserCircle } from "react-icons/fa";
import icon from "../../assets/loboB.png";
import { jwtDecode } from "jwt-decode";

const Navbar = ({ setShowLogin }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { token, setToken } = useContext(Context);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleUserIconClick = () => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      // Decode token to get user role
      const decoded = jwtDecode(token);
      const userRole = decoded.role;

      // Navigate based on role
      switch (userRole) {
        case "admin":
          navigate("/admin");
          break;
        case "trainer":
          navigate("/trainer");
          break;
        default:
          navigate("/userpanel");
      }
    } catch (error) {
      // If token is invalid or expired
      localStorage.removeItem("token");
      setToken("");
      navigate("/login");
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userRole"); // Can be removed in a future cleanup
    setToken("");
    navigate("/");
  };

  return (
    <div>
      <nav className="bg-[#191919] w-full z-20 top-0 start-0 text-white">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4 bg-[#191919] md:bg-transparent">
          <a
            href="/"
            className="flex items-center space-x-3 rtl:space-x-reverse"
          >
            <img src={icon} className="h-10 " alt="Flowbite Logo" />
          </a>
          <div className="flex md:order-2 space-x-3 rtl:space-x-revers md:hidden">
            <button
              onClick={toggleMenu}
              type="button"
              className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm rounded-lg md:hidden border-2 hover:bg-orange-500 hover:text-white hover:border-orange-500"
              aria-controls="navbar-sticky"
              aria-expanded={isMenuOpen}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
            </button>
          </div>
          <div
            className={`items-center justify-between w-full md:flex md:w-auto md:order-1 ${
              isMenuOpen ? "block" : "hidden"
            }`}
            id="navbar-sticky"
          >
            <ul className="flex flex-col gap-2 p-4 md:p-0 mt-4 font-medium border rounded-lg md:bg-transparent bg-[#191919] md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 text-center items-center">
              <li>
                <Link
                  to="/kombinezony"
                  className="block py-2 px-3 text-white uppercase rounded hover:text-orange-500 cursor-pointer"
                >
                  Kombinezony
                </Link>
              </li>
              <li>
                <Link
                  to="/pierwsza-wizyta"
                  className="block py-2 px-3 text-white uppercase rounded hover:text-orange-500 cursor-pointer"
                >
                  Pierwsza wizyta
                </Link>
              </li>
              <li>
                <Link
                  to="/oferta"
                  className="block py-2 px-3 text-white uppercase rounded hover:text-orange-500 cursor-pointer"
                >
                  Oferta
                </Link>
              </li>
              <li>
                <Link
                  to="/kontakt"
                  className="block py-2 px-3 text-white uppercase rounded hover:text-orange-500 cursor-pointer"
                >
                  Kontakt
                </Link>
              </li>
              <li className="flex items-center gap-4">
                <div className="navbar-right relative z-20">
                  <FaUserCircle
                    className="text-white w-8 h-8 cursor-pointer hover:text-orange-500"
                    onClick={handleUserIconClick}
                  />
                </div>
                {token && (
                  <button
                    onClick={logout}
                    className="text-white hover:text-orange-500"
                  >
                    Wyloguj
                  </button>
                )}
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
